module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_schlafzimmer_oben_links_01.342ce2bd.jpg";